import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type MoveCharacteristicsToNewGroupRequest as SchemaMoveCharacteristicsToNewGroupRequest } from '../schemas/MoveCharacteristicsToNewGroupRequest';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Characteristics
 */
export const MoveCharacteristicsToNewGroupContentType = 'application/json' as const;
export type MoveCharacteristicsToNewGroupRequest = SchemaMoveCharacteristicsToNewGroupRequest;
export type MoveCharacteristicsToNewGroupResponses = LinkCommonErrorResponses & {
    /**
     * @description New group created and characteristics moved successfully
     */
    '200': {};
};
export type MoveCharacteristicsToNewGroupResponseSuccess = undefined;
export type MoveCharacteristicsToNewGroupSearchParams = undefined;
export type MoveCharacteristicsToNewGroupPathParameters = undefined;
export const MoveCharacteristicsToNewGroupUrl = '/characteristics/groups/move-to-new' as const;
export const MoveCharacteristicsToNewGroupMethod = 'POST' as const;
export const getMoveCharacteristicsToNewGroupUrl = (_params?: MoveCharacteristicsToNewGroupPathParameters) =>
    MoveCharacteristicsToNewGroupUrl;
